<template>
  <form @submit.prevent="save">
    <v-card>
      <v-toolbar
        flat
        color="primary"
      >
        <v-toolbar-title>Create API Token</v-toolbar-title>
        <v-spacer />
      </v-toolbar>
      <v-card-text>
        <span>
          API tokens allow third-party services to authenticate with our application on your behalf.
        </span>
      </v-card-text>
      <v-card-text>
        <v-text-field
          v-model="form.name"
          label="Name"
          required

          :class="{ 'is-invalid': form.errors.name }"
          :error="form.errors.name"
          :error-messages="form.errors.name"
        />
      </v-card-text>
      <v-card-text>
        <span>
          Permissions
        </span>
        <v-checkbox
          v-for="permission in availablePermissions"
          :key="permission"
          v-model="form.permissions"
          :label="permission"
          :value="permission"
          hide-details
        />
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="primary"
          type="submit"
        >
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-dialog v-model="tokenDialog" persistent max-width="600px">
      <v-card>
        <v-toolbar flat>
          <v-toolbar-title>API Token</v-toolbar-title>
          <v-spacer />
          <v-btn icon @click="displayingToken = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          Please copy your new API token. For your security, it won't be shown again.
        </v-card-text>
        <v-card-text v-if="$page.props.jetstream.flash.token">
          {{ $page.props.jetstream.flash.token }}
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="primary" text @click="displayingToken = false">
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </form>
</template>

<script>
export default {
   props: {
      defaultPermissions: {
         type: Array,
         default () { return [] }
      },
      availablePermissions: {
         type: Array,
         default () { return [] }
      },
   },
   data () {
      return {
         form: this.$inertia.form({
            name: null,
            permissions: null
         }),
         tokenDialog: false
      }
   },
   created () {
      this.form.permissions = this.defaultPermissions
   },
   methods: {
      save () {
         this.form.post(this.route('api-tokens.store'), {
            preserveScroll: true,
         }).then(response => {
            if (!this.form.hasErrors()) {
               this.tokenDialog = true
            }
         })
      },
   }
}
</script>

<style>
</style>
